// extracted by mini-css-extract-plugin
export default {"SideNavbar":"style_SideNavbar__AT7PR","logoSVG":"style_logoSVG__V1YEa","NavItemBG":"style_NavItemBG__5cq+7"};